import ApiURL from './api.url'
import request from './request'

class Api {

  request = request.request

  hello_getAll = ApiURL.of('hello/getAll').noSecure().noHobby().setPOST()

  account_login = ApiURL.of('account/login').noSecure().noHobby().setPOST()
  account_getMiniWxSession = ApiURL.of('account/getMiniWxSession').noSecure().noHobby().setPOST()
  account_getBdMiniSession = ApiURL.of('account/getBdMiniSession').noSecure().noHobby().setPOST()
  account_loginByWxMini = ApiURL.of('account/loginByWxMini').noSecure().noHobby().setPOST()
  account_loginByBdMini = ApiURL.of('account/loginByBdMini').noSecure().noHobby().setPOST()
  handshake = ApiURL.of('handshake').noSecure().noHobby().setPOST()
  verificationCode = ApiURL.of('verificationCode').noSecure().noHobby().setPOST()
  account_bindPhoneNumber = ApiURL.of('account/bindPhoneNumber').setPOST()
  account_replacePhoneNumber = ApiURL.of('account/replacePhoneNumber').setPOST()
  account_bindWeChat = ApiURL.of('account/bindWeChat').setPOST()
  account_bindQQ = ApiURL.of('account/bindQQ').setPOST()
  account_unbindAccount = ApiURL.of('account/unbindAccount').setPOST()

  uptoken_picure = ApiURL.of('uptoken/picture').noHobby().setGET()
  uptoken_video = ApiURL.of('uptoken/video').noHobby().setGET()

  profile_update_attribute = ApiURL.of('profile/update_attribute').noHobby().setPOST()

  user = ApiURL.of('user').setGET()
  user_info = ApiURL.of('user/info').setGET()
  user_miniUser = ApiURL.of('user/miniUser').setGET()
  user_get_numeric = ApiURL.of('user/get_numeric').setGET()
  user_get_unreadCount = ApiURL.of('user/get_unreadCount').setGET()
  user_myWxInviteUrl = ApiURL.of('user/myWxInviteUrl').setGET()
  user_isPromoter = ApiURL.of('user/isPromoter').setGET()
  user_contains_name = ApiURL.of('user/contains_name').setGET()

  user_relation_follow_extra = ApiURL.of('user_follow/follow_extra').setGET()
  user_relation_follow = ApiURL.of('user_follow/follow').needLogin().setPOST()
  user_relation_following = ApiURL.of('user_follow/following').setGET()
  user_relation_follower = ApiURL.of('user_follow/follower').setGET()
  user_relation_block = ApiURL.of('user_follow/block').setPOST()
  user_relation_block_list = ApiURL.of('user_follow/block_list').setGET()
  user_relation_black = ApiURL.of('user_follow/black').setPOST()
  user_relation_black_list = ApiURL.of('user_follow/black_list').setGET()

  sign_in = ApiURL.of('sign_in').setPOST()
  sign_in_today = ApiURL.of('sign_in/today').setGET()
  sign_in_detailOfUser = ApiURL.of('sign_in/detailOfUser').setGET()
  sign_in_history = ApiURL.of('sign_in/history').setGET()
  sign_in_all = ApiURL.of('sign_in/all').setGET()
  sign_in_set_label = ApiURL.of('sign_in/set_label').setPOST()
  sign_in_recom_lbl = ApiURL.of('sign_in/recommond_label').setGET()

  skatepark_create = ApiURL.of('skatepark/create').setPOST()
  skatepark_all = ApiURL.of('skatepark/all').setGET()
  skatepark_list = ApiURL.of('skatepark/list').setGET()
  skatepark_listByIds = ApiURL.of('skatepark/listByIds').setPOST()
  skatepark_detail = ApiURL.of('skatepark/detail').setGET()
  skatepark_nearby_list = ApiURL.of('skatepark/nearby_list').setGET()

  exhibition = ApiURL.of('exhibition').setGET()
  exhibition_modify = ApiURL.of('exhibition/modify').setPOST()
  exhibition_all_list = ApiURL.of('exhibition/all_list').setGET()

  sys_label_create = ApiURL.of('sys_label/create').setPOST()
  sys_label_modify = ApiURL.of('sys_label/modify').setPOST()
  sys_label_list = ApiURL.of('sys_label/list').setGET()
  sys_label_manager_list = ApiURL.of('sys_label/manager_list').setGET()

  talking = ApiURL.of('talking').setGET()
  talking_list = ApiURL.of('talking/list').setGET()
  talking_list_ex = ApiURL.of('talking/list_ex').setGET()
  talking_hot_list = ApiURL.of('talking/hot_list').setGET()
  talking_create = ApiURL.of('talking/create').setPOST()
  talking_modify = ApiURL.of('talking/modify').setPOST()
  talking_newest_activity = ApiURL.of('talking/newest_activity').setGET()
  talking_activity_list = ApiURL.of('talking/activity_list').setGET()
  talking_teletext_list = ApiURL.of('talking/teletext_list').setGET()
  topic_list_by_talking = ApiURL.of('topic/list_by_talking').setGET()

  topic = ApiURL.of('topic').setGET()
  topic_list = ApiURL.of('topic/list').setGET()
  topic_hot = ApiURL.of('topic/hot').setGET()
  topic_feeds = ApiURL.of('topic/feeds').setGET()
  topic_feeds_unReadCount = ApiURL.of('topic/feeds/unReadCount').setGET()
  topic_extra = ApiURL.of('topic/extra').setGET()
  topic_getByReplyId = ApiURL.of('topic/getByReplyId').setGET()
  topic_contains_key = ApiURL.of('topic/contains_key').setGET()
  topic_user = ApiURL.of('topic/user').setGET()
  topic_view = ApiURL.of('topic/view').setPOST()
  topic_agree = ApiURL.of('topic_agree').needLogin().noHobby().setPOST()
  my_collection = ApiURL.of('collection').needLogin().noHobby().setGET()
  topic_like_list = ApiURL.of('like').noHobby().setGET()
  topic_list_by_text_extra = ApiURL.of('topic/list_by_text_extra').setGET()

  reply = ApiURL.of('reply').noHobby().setGET()
  reply_agree = ApiURL.of('reply_agree').noHobby().setPOST()
  sub_reply = ApiURL.of('sub_reply').noHobby().setGET()
  sub_reply_reply = ApiURL.of('sub_reply/reply').noHobby().setGET()

  course_detail = ApiURL.of('course').setGET()
  course_taxonomy = ApiURL.of('course_taxonomy').setGET()
  course_topic_list = ApiURL.of('course/topic_list').setGET()
  course_user_challenge_topic_list = ApiURL.of('course/user_challenge_topic_list').setGET()
  course_user_challenge_course_list = ApiURL.of('course/user_challenge_course_list').setGET()
  course_search_course = ApiURL.of('course/search_course').setGET()

  deep_link_wrap_getByShortUrl = ApiURL.of('deep_link_wrap/getByShortUrl').noHobby().setGET()

  biz_mall = ApiURL.of('biz/mall').setGET()
  biz_mall_groupExhibitionList = ApiURL.of('biz/mall/groupExhibitionList').setGET()
  biz_goods_mallGoods = ApiURL.of('biz/goods/mallCategory').setGET()
  biz_goods = ApiURL.of('biz/goods').setGET()
  biz_goods_detailByGoodsSpecId = ApiURL.of('biz/goods/detailByGoodsSpecId').setGET()
  biz_goods_listByBrand = ApiURL.of('biz/goods/listByBrand').setGET()
  biz_goods_buyNowInfo = ApiURL.of('biz/goods/buyNowInfo').setGET()

  biz_goodsComment = ApiURL.of('biz/goodsComment').noHobby().setPOST()
  biz_goodsComment_all = ApiURL.of('biz/goodsComment/all').noHobby().setGET()
  biz_goodsComment_modify = ApiURL.of('biz/goodsComment/modify').noHobby().setPOST()

  biz_brand_brandGoodsTypes = ApiURL.of('biz/brand/brandGoodsTypes').setGET()

  biz_suite = ApiURL.of('biz/suite').setGET()
  biz_suite_extra = ApiURL.of('biz/suite/extra').setGET()
  biz_suite_byShare = ApiURL.of('biz/suite/byShare').setGET()
  biz_suite_ongoing = ApiURL.of('biz/suite/ongoing').setGET()
  biz_suite_setGoodsSpec = ApiURL.of('biz/suiteItem/setGoodsSpec').setPOST()
  biz_suite_cleanGoodsSpec = ApiURL.of('biz/suiteItem/cleanGoodsSpec').setPOST()
  biz_suite_supportBrandMenu = ApiURL.of('biz/suiteItem/supportBrandMenu').setGET()
  biz_suite_suiteItemTypes = ApiURL.of('biz/suiteItem/suiteItemTypes').setGET()
  biz_suite_setGoodsSpecByGoodsSnapshot = ApiURL.of('biz/suiteItem/setGoodsSpecByGoodsSnapshot').setPOST()
  biz_suite_cleanGoodsSpecByGoodsSnapshot = ApiURL.of('biz/suiteItem/cleanGoodsSpecByGoodsSnapshot').setPOST()
  biz_suite_replaceGoodsSpecForSuiteOrder = ApiURL.of('biz/suiteItem/replaceGoodsSpecForSuiteOrder').setPOST()

  biz_goodsSpec = ApiURL.of('biz/goodsSpec').setGET()
  biz_goodsSpec_suiteItemBrands = ApiURL.of('biz/goodsSpec/suiteItemBrands').setGET()
  biz_goodsSpec_suiteItemGoods = ApiURL.of('biz/goodsSpec/suiteItemGoods').setGET()
  biz_goodsSpec_goodsSpecRecord = ApiURL.of('biz/goodsSpec/goodsSpecRecord').setGET()

  biz_shoppingCart = ApiURL.of('biz/shoppingCart').setGET()
  biz_shoppingCart_operator = ApiURL.of('biz/shoppingCart/operator').needLogin().setPOST()
  biz_shoppingCart_createTempItem = ApiURL.of('biz/shoppingCart/createTempItem').needLogin().setPOST()

  biz_settlement_shoppingCart = ApiURL.of('biz/settlement/shoppingCart').setPOST()
  biz_settlement_selectCoupon = ApiURL.of('biz/settlement/selectCoupon').setPOST()

  biz_deliveryAddress = ApiURL.of('biz/deliveryAddress').noHobby().setGET()
  biz_deliveryAddress_setDefault = ApiURL.of('biz/deliveryAddress/setDefault').noHobby().setPOST()

  biz_order = ApiURL.of('biz/order').setGET()
  biz_order_detailBySid = ApiURL.of('biz/order/detailBySid').setGET()
  biz_order_create_shoppingCart = ApiURL.of('biz/order/create/shoppingCart').setPOST()
  biz_order_confirmReceipt = ApiURL.of('biz/order/confirmReceipt').setPOST()
  biz_order_cancel = ApiURL.of('biz/order/cancel').setPOST()
  biz_order_modifyAddress = ApiURL.of('biz/order/modifyAddress').setPOST()

  biz_couponActivity_list = ApiURL.of('biz/couponActivity/list').setGET()
  biz_couponActivity = ApiURL.of('biz/couponActivity').setGET()
  biz_couponPlan_findAllByCanReceive = ApiURL.of('biz/couponPlan/findAllByCanReceive').setGET()
  biz_couponPlan_receive = ApiURL.of('biz/couponPlan/receive').setPOST()
  biz_couponPlan_listByActivityId = ApiURL.of('biz/couponPlan/listByActivityId').setGET()
  biz_couponItem_myEffectiveList = ApiURL.of('biz/couponItem/myEffectiveList').setGET()

  admin_promotion_list = ApiURL.of('promotion/list').setAdmin().noHobby().setGET()
  admin_promotion_modify = ApiURL.of('promotion/modify').setAdmin().noHobby().setPOST()
  admin_promotion_promotionItems = ApiURL.of('promotion/promotionItems').setAdmin().noHobby().setGET()
  admin_promotion_promotionItem = ApiURL.of('promotion/promotionItem').setAdmin().noHobby().setGET()
  admin_promotion_promotionItem_save = ApiURL.of('promotion/promotionItem/modify').setAdmin().noHobby().setPOST()

  pay_wxminiPay = ApiURL.of('pay/wxminiPay').noHobby().setPOST()
  pay_bdMiniPay = ApiURL.of('pay/bdMiniPay').noHobby().setPOST()

  region_provinceList = ApiURL.of('region/provinceList').noSecure().noHobby().setGET()
  region_cityList = ApiURL.of('region/cityList').noSecure().noHobby().setGET()
  region_districtList = ApiURL.of('region/districtList').noSecure().noHobby().setGET()

  expressTracking = ApiURL.of('expressTracking').noHobby().setGET()

  im_conversation_list = ApiURL.of('im/conversation/list').setGET()
  im_conversation_deleall_listte = ApiURL.of('im/conversation').setDELETE()
  im_conversation_setIsTop = ApiURL.of('im/conversation/setIsTop').setPOST()
  im_conversation_deleteIsTop = ApiURL.of('im/conversation/deleteIsTop').setPOST()
  im_conversation_clearAllUnreadCount = ApiURL.of('im/conversation/clearAllUnreadCount').setDELETE()
  im_notice_list = ApiURL.of('im/notice/list').setGET()
  im_notice_delete = ApiURL.of('im/notice').setDELETE()

  im_o2o_history_list = ApiURL.of('im/o2o/history_list').setGET()
  im_o2o_newest_list = ApiURL.of('im/o2o/newest_list').setGET()
  im_o2o_send = ApiURL.of('im/o2o/send').setPOST()
  im_o2o_delete = ApiURL.of('im/o2o/delete').setPOST()
  im_o2o_fromInfo = ApiURL.of('im/o2o/fromInfo').setPOST()
  im_o2o_orderConfirm = ApiURL.of('im/o2o/orderConfirm').setPOST()
  im_o2o_getMainUser = ApiURL.of('im/o2o/getMainUser').setGET()

  relate2me_remind = ApiURL.of('remind').noHobby().setGET()

  point_exchangeLuckyFactor = ApiURL.of('point/exchangeLuckyFactor').setPOST()

  exchangeCode = ApiURL.of('exchangeCode').setGET()
  exchangeCode_create = ApiURL.of('exchangeCode/create').setPOST()
  exchangeCode_exchange = ApiURL.of('exchangeCode/exchange').setPOST()
  exchangePlan_myPlan = ApiURL.of('exchangePlan/myPlan').setGET()

  lottery_plan = ApiURL.of('lottery/lotteryPlan').setGET()
  lottery_plan_ongoing = ApiURL.of('lottery/lotteryPlan/ongoing/luckySaturday').setGET()
  lottery_plan_detail = ApiURL.of('lottery/lotteryPlan/detailOfUser').setGET()
  lottery_plan_create = ApiURL.of('lottery/lotteryPlan/create').setPOST()
  lottery_plan_openLottery = ApiURL.of('lottery/lotteryPlan/openLottery').setPOST()
  lottery_plan_updateStatus = ApiURL.of('lottery/lotteryPlan/updateStatus').setPOST()
  lottery_lucky_factor = ApiURL.of('lottery/lucky_factor').setGET()
  lottery_prize = ApiURL.of('lottery/prize').setGET()
  lottery_prize_create = ApiURL.of('lottery/prize/create').setPOST()
  lottery_prize_allocation = ApiURL.of('lottery/prize_allocation').setGET()
  lottery_prize_allocation_reset = ApiURL.of('lottery/prize_allocation/reset').setPOST()

  report = ApiURL.of('report').setPOST()
  report_all_list = ApiURL.of('report/all_list').setGET()
  report_modify_status = ApiURL.of('report/modify_status').setPOST()

  global_param_list = ApiURL.of('global_param/list').noHobby().setGET()
  global_param_modify = ApiURL.of('global_param/modify').noHobby().setPOST()

  admin_launch_ad_list = ApiURL.of('launch_ad/list').setAdmin().noHobby().setGET()
  admin_launch_ad_modify = ApiURL.of('launch_ad/modify').setAdmin().noHobby().setPOST()

  custom_deck_cover = ApiURL.of('custom_deck_cover').setPOST()
}

export default new Api()
